import Vue from 'vue';
import VueHtml5Editor from 'vue-html5-editor';
import VTrackevent from 'vue-trackevent';
import './assets/scripts/hotfix';
import './webim.config';
import createApp from './entry';
import VueEditorConfig from './editor.config';
import TrackeventConfig from './trackevent.config';
//  import { AgoraEduSDK } from 'agora-classroom-sdk'


Vue.use(VueHtml5Editor, VueEditorConfig.options);
Vue.use(VTrackevent, TrackeventConfig); // 配置数据埋点
// Vue.use(AgoraEduSDK);

createApp({
  created() {
    document.querySelector('.app-css3-loading').style.display = 'none';
    this.window = window;
  },
}).then(({ app, fileConfigs }) => {
  app.$mount('#app');
  if (typeof window !== 'undefined') {
    const AgoraEdu = require('agora-classroom-sdk');
    Vue.prototype.$AgoraEdu = AgoraEdu;
  }

  window.vueApplication = app;
  // 移除 rem 自适应逻辑，避免动态改写 html 内联 font-size 导致页面异常。
  document.documentElement.style.removeProperty('font-size');
  window.addEventListener('resize', () => {
    app.$store.commit('updateWindowWidth', document.body.offsetWidth);
  });
  app.$store.commit('updateWindowWidth', document.body.offsetWidth);
  app.$api.userCenter({
    random: new Date().getTime()
  }).then(({
    data: res
  }) => {
    app.$store.commit('updateUserinfo', res.data); // 缓存个人信息
  });
  app.$api.permitList({
    random: new Date().getTime()
  }).then(({
    data: res
  }) => {
    app.$store.commit('updatePermitList', res.data.list || []); // 缓存权限信息
  });
  app.$api.maintenanceList({
    random: new Date().getTime()
  }).then(({
     data: res
  }) => {
    app.$store.commit('updateQiniuTime', res.data[0].qn_time || '');
    app.$store.commit('updateMysqlTime', res.data[0].my_time || '');
  })
  app.$api.hxtime({
    random: new Date().getTime()
  }).then(({
     data: res
  }) => {
    app.$store.commit('updateHxSave', res.data || '');
  })
  app.$store.commit('updateFileConfigs', fileConfigs); // 缓存文件目录
  console.log(
    `%c 更新时间 %c ${process.env.CODE_VERSION} %c`,
    'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px; color: #fff',
    'background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0; color: #fff',
    'background:transparent;'
  );
})
